import { Box, Select, TextField, FormControl, InputLabel, MenuItem } from "@mui/material";
import { useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createDashboardUser } from "../clients/FixieApiClient";
import { LoadingButton } from "@mui/lab";
import DashboardPage from "../layouts/DashboardPage";
import trackEvent from "../utils/trackEvent";

export default () => {
  const { register, handleSubmit } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (data: FieldValues) => {
    setIsLoading(true);
    const response = await createDashboardUser(data);
    if (response.ok) {
      toast.success(`You have invited ${data.fullName} to join your team`);
      trackEvent('add_user');
      navigate("/users");
    }
    setIsLoading(false);
  }

  return (
    <DashboardPage title="Invite Team Member">
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ padding: '1rem' }}>
          <TextField {...register("fullName")} required fullWidth margin="dense" label="Full Name" type="text" variant="outlined" />
          <TextField  {...register("email")} required fullWidth margin="dense" label="Email" type="email" variant="outlined" />
          <FormControl fullWidth margin="dense">
            <InputLabel id="select-role-label">Role</InputLabel>
            <Select {...register("role")} defaultValue="standard" label="Region" labelId="select-role-label" required fullWidth variant="outlined">
              <MenuItem value="standard">Standard</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
            </Select>
          </FormControl>
          <LoadingButton
            loading={isLoading}
            disableElevation
            variant="contained"
            type="submit"
            fullWidth
            sx={{ mt: 2, mb: 2, height: "56px" }}
          >
            <span>Done</span>
          </LoadingButton>
        </Box>
      </Box >
    </DashboardPage>
  )
}
